export const ImportStudentEnum = {
  Default: 1,
  Auto: 2,
  DirectCert: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ImportStudentEnum.js